export default class BuildingVerticalPlanning {
  constructor(api) {
    this.api = api;
  }

  getFloor(floorUuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/buildingfloor/" + floorUuid)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  storeFloor(floorData, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/buildingfloor", floorData)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  updateFloor(floorData, onSuccess, onError) {
    return this.api.http_fibercloud
      .put("v1/buildingfloor", floorData)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      })
  }

  deleteFloor(floorUuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .delete("v1/buildingfloor", floorUuid)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      })
  }

  deleteFloors(floorsList, onSuccess, onError) {
    return this.api.http_fibercloud
      .delete("v1/buildingfloor", floorsList)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      })
  }

  getColumn(columnUuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/buildingcolumn/" + columnUuid)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      })
  }

  storeColumn(columnData, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/buildingcolumn", columnData)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      })
  }

  udpateColumn(columnData, onSuccess, onError) {
    return this.api.http_fibercloud
      .put("v1/buildingcolumn", columnData)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      })
  }

  deleteColumn(columnUuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .delete("v1/buildingcolumn/" + columnUuid)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      })
  }

  deleteColumns(columnsList, onSuccess, onError) {
    return this.api.http_fibercloud
      .delete("v1/buildingcolumn", columnsList)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      })
  }

  getFloorbox(floorboxUuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/floorbox/" + floorboxUuid)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      })
  }

  storeFloorbox(floorboxData, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/floorbox", floorboxData)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      })
  }

  updateFloorbox(floorboxData, onSuccess, onError) {
    return this.api.http_fibercloud
      .put("v1/floorbox", floorboxData)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      })
  }

  deleteFloorbox(floorboxUuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .delete("v1/floorbox/" + floorboxUuid)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      })
  }

  deleteFloorboxes(floorboxesList, onSuccess, onError) {
    return this.api.http_fibercloud
      .delete("v1/floorbox", floorboxesList)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      })
  }

  getFraction(fractionUuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/buildingfraction/" + fractionUuid)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      })
  }

  storeFraction(fractionData, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/buildingfraction", fractionData)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      })
  }

  updateFraction(fractionData, onSuccess, onError) {
    return this.api.http_fibercloud
      .put("v1/buildingfraction", fractionData)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      })
  }

  deleteFraction(fractionUuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .delete("v1/buildingfraction/" + fractionUuid)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      })
  }

  deleteFractions(fractionsList, onSuccess, onError) {
    return this.api.http_fibercloud
      .delete("v1/buildingfraction", fractionsList)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      })
  }
}



// WEBPACK FOOTER //
// ./src/api/buildingVerticalPlanning.js